import React from 'react';
import { FormattedPlural, injectIntl, intlShape } from 'react-intl';
import { number } from 'prop-types';
import { iFMessage, FMessage } from '../../hoc/IntlComponents';

const propTypes = {
  hold: number.isRequired,
  intl: intlShape.isRequired,
};

const OfferPostClick = ({ hold, intl }) => (
  <div className="offer-determination">
    <p className="offer-determination-title">
      <FMessage id="offer.postclick.title" />
    </p>
    <p className="offer-determination-value">
      {hold}{' '}
      <FormattedPlural
        value={hold}
        one={iFMessage({ intl, id: 'offer.postclick.day' })}
        other={iFMessage({ intl, id: 'offer.postclick.days' })}
      />
    </p>
  </div>
);

OfferPostClick.propTypes = propTypes;

export default injectIntl(OfferPostClick);
